import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PortalProtectedRoute = () => {
  const { token } = useSelector(state => state.portalAuth);
  return token ? <Outlet /> : <Navigate to="/portal/login" replace />;
};

export default PortalProtectedRoute;
